'use client';

import { useEffect, useState } from 'react';
import { usePrivate } from '@/components/private/PrivateContext';
import { useEulaAcceptanceFlow } from './useEulaAcceptanceFlow';
import { TermsAndConditionsDialog } from '@/components/termsAndConditionsDialog';
import { SurveyDialog } from '@/components/surveyDialog';
import { useSurveyFlow } from './useSurveyFlow';
import { getSessionStorageItem } from '@/lib/browserStorage';
import { RoleUserOrgAssociationDto } from '@/apiClient';

type TProps = {
  onFinishFlow: (organisations: RoleUserOrgAssociationDto[]) => void;
};
export function PostSignUpFlow({ onFinishFlow }: TProps) {
  const { userProfile, userOrganisations } = usePrivate();

  const {
    eulaDialogOpen,
    isAcceptingEula,
    onClickBackEula,
    onClickAcceptEula,
  } = useEulaAcceptanceFlow();

  const {
    isSubmittingSurvey,
    surveyDialogOpen,
    onClickSkipQuestion,
    onClickSubmitSurvey,
  } = useSurveyFlow();

  const isEulaAccepted = userProfile?.isEulaAccepted;
  const hasSubmittedSurvey =
    userProfile?.surveyResponse?.surveyResponseEntityId;

  const surveySkipped =
    getSessionStorageItem<boolean>('surveySkipped') || false;
  const [flowDone, setFlowDone] = useState(false);

  useEffect(() => {
    if (!flowDone || !userOrganisations) return;

    onFinishFlow(userOrganisations!);
  }, [onFinishFlow, flowDone, userOrganisations]);

  if (!isEulaAccepted) {
    return (
      <TermsAndConditionsDialog
        loading={isAcceptingEula}
        open={eulaDialogOpen}
        onClickBack={onClickBackEula}
        onClickAccept={onClickAcceptEula}
      />
    );
  }

  if (isEulaAccepted && !hasSubmittedSurvey && !surveySkipped) {
    return (
      <SurveyDialog
        loading={isSubmittingSurvey}
        open={surveyDialogOpen}
        onClickSkip={() => {
          onClickSkipQuestion();
          setFlowDone(true);
        }}
        onClickSubmit={(checkedIds) => {
          onClickSubmitSurvey(checkedIds);
          setFlowDone(true);
        }}
      />
    );
  }

  return null;
}
